module.exports = __webpack_public_path__ + "media/72_BL.23c58c0a.mp3";